import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import { userTrade } from '../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/userTrade';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { OpenPctButton } from '../../../../../../atomic/buttons/openPctButton/OpenPctButton';
import TextButton from '../../../../../../atomic/buttons/textButton/TextButton';
import { determineTradeTypes } from '../../quickTradeModule/determineTradeTypes';
import { TopRowBox } from '../topRowBox/TopRowBox';
import { TopRowBoxIncDecButtons } from '../topRowBox/TopRowBoxIncDecButtons';
import { TopRowInput } from '../topRowBox/TopRowInput';
import { TopRowPctQtySwitch } from '../topRowBox/TopRowPctQtySwitch';

export const OpenRow = observer(({ tradePlanId, type, setType }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const { positionSymbol, id } = tradePlan;
  const metrics = tradePlanStore.getTradePlanPositionMetrics(tradePlanId);
  const position = metrics?.position ?? null;
  const totalTradePlanQty = metrics?.entryQuantity ?? null;
  const openOrderType = determineTradeTypes(tradePlan)[0]?.val; //tradePlan.goLong ? 'BTO' : 'STO';
  const [qty, setQty] = useState(1);

  return (
    <>
      <TopRowPctQtySwitch
        backgroundColor={colors.grey}
        width="100px"
        type={type}
        setType={setType}
      />
      {type === 'pct' ? (
        <>
          {position ? (
            <>
              <OpenPctButton
                margin="0 5px 0 0"
                percent={25}
                quantity={Math.ceil(totalTradePlanQty * 0.25)}
                clickHandler={() =>
                  userTrade(
                    id,
                    openOrderType,
                    Math.ceil(totalTradePlanQty * 0.25),
                    'MKT',
                    null,
                    positionSymbol
                  )
                }
              />
              <OpenPctButton
                margin="0 5px 0 0"
                percent={50}
                quantity={Math.ceil(totalTradePlanQty * 0.5)}
                clickHandler={() =>
                  userTrade(
                    id,
                    openOrderType,
                    Math.ceil(totalTradePlanQty * 0.5),
                    'MKT',
                    null,
                    positionSymbol
                  )
                }
              />
              <OpenPctButton
                margin="0 5px 0 0"
                percent={75}
                quantity={Math.ceil(totalTradePlanQty * 0.75)}
                clickHandler={() =>
                  userTrade(
                    id,
                    openOrderType,
                    Math.ceil(totalTradePlanQty * 0.75),
                    'MKT',
                    null,
                    positionSymbol
                  )
                }
              />
              <OpenPctButton
                margin="0 5px 0 0"
                percent={100}
                quantity={totalTradePlanQty}
                clickHandler={() =>
                  userTrade(
                    id,
                    openOrderType,
                    totalTradePlanQty,
                    'MKT',
                    null,
                    positionSymbol
                  )
                }
              />
            </>
          ) : (
            <>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
            </>
          )}
        </>
      ) : (
        <>
          {position ? (
            <>
              <TopRowBoxIncDecButtons
                totalTradePlanQty={totalTradePlanQty}
                qty={qty}
                setQty={setQty}
                width="100px"
                backgroundColor={colors.grey}
                type="open"
              />
              <TopRowInput
                qty={qty}
                setQty={setQty}
                width="100px"
                backgroundColor={colors.grey}
              />
              <TextButton
                margin="0 5px 0 0"
                width="100px"
                color={colors.lightGrey}
                backgroundColor={colors.green}
                fontSize="medium"
                clickHandler={() =>
                  userTrade(
                    tradePlanId,
                    openOrderType,
                    qty,
                    'MKT',
                    null,
                    positionSymbol
                  )
                }
              >
                {`OPEN ${qty}`}
              </TextButton>
            </>
          ) : (
            <>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">--</TopRowBox>
              <TopRowBox backgroundColor={colors.grey} color={colors.lightGrey} width="100px">OPEN --</TopRowBox>
            </>
          )}
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="100px"
          ></TopRowBox>
        </>
      )}
    </>
  );
});
